// Shopify Section Rendering API: lädt nur diese Section als JSON, nicht die ganze Seite
// Event Delegation → funktioniert auch nach Facetten/Sortier-Reload durch facets.js

document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#load-more-btn');
  if (!btn) return;

  const currentPage = parseInt(btn.dataset.currentPage, 10);
  const totalPages = parseInt(btn.dataset.totalPages, 10);
  const label = btn.dataset.label;
  const sectionId = btn.dataset.sectionId;

  if (currentPage >= totalPages) { btn.closest('.load-more-container').remove(); return; }

  btn.disabled = true;
  btn.textContent = 'Wird geladen …';

  const nextPage = currentPage + 1;
  const url = window.location.pathname + '?page=' + nextPage + '&section_id=' + sectionId;

  try {
    const res = await fetch(url);
    const text = await res.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const newItems = doc.querySelectorAll('#product-grid > li');
    const grid = document.getElementById('product-grid');

    newItems.forEach(function (item) { grid.appendChild(item); });

    btn.dataset.currentPage = nextPage;

    if (nextPage >= totalPages) {
      btn.closest('.load-more-container').remove();
    } else {
      btn.disabled = false;
      btn.textContent = label;
    }
  } catch (err) {
    console.error('Load more fehlgeschlagen:', err);
    btn.disabled = false;
    btn.textContent = 'Fehler – erneut versuchen';
  }
});
